import { useEffect, useState } from 'react'
import { useAuth } from 'src/context/AuthContext'
import { filterNames } from 'src/utils/config/config'

interface CustomLabels {
  am_name: string
  vb_name: string
  vb_platform: string
  b_name: string
  slug: string
}

export function useCustomLabels() {
  const { orgConfig } = useAuth()
  const [labels, setLabels] = useState<CustomLabels>(filterNames)

  useEffect(() => {
    if (orgConfig?.customLabels) {
      // Build labels object with fallbacks for each field
      const customLabels: CustomLabels = {
        am_name: orgConfig.customLabels.am_name || filterNames.am_name,
        vb_name: orgConfig.customLabels.vb_name || filterNames.vb_name,
        vb_platform: orgConfig.customLabels.vb_platform || filterNames.vb_platform,
        b_name: orgConfig.customLabels.b_name || filterNames.b_name,
        slug: orgConfig.customLabels.slug || filterNames.slug
      }
      setLabels(customLabels)
    } else {
      // No custom labels from Firebase, use all defaults
      setLabels(filterNames)
    }
  }, [orgConfig])

  return labels
}